import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { theme } from 'configs/styled';
import { useIsWebView } from 'hooks/useIsWebView';
import React from 'react';
import { MENU_STATUSES } from 'services/driverPortal/DriverPortal.interface';
import { StatusTag } from './DocumentsReviewStatus';

export enum Status {
  REQUIRED = 'กรุณากรอกข้อมูล',
  PENDING = 'ยังไม่มีข้อมูล',
  SUBMITTED = 'รอตรวจสอบ',
  REJECTED = 'เอกสารไม่ถูกต้อง',
  APPROVED = 'อนุมัติ',
  EXPIRED = 'หมดอายุ',
  START_TRAINING = 'เริ่มต้นการอบรม',
  WAITING = 'รอผลทดสอบ',
  CONFIRM = 'รอยืนยันการอบรม',
}
interface IDocumentStatusProps {
  name: string;
  color: string;
  textColor: string;
}

const webViewDisplayStatuses: string[] = [
  Status.REQUIRED,
  Status.PENDING,
  Status.SUBMITTED,
  Status.REJECTED,
  Status.EXPIRED,
  Status.START_TRAINING,
  Status.WAITING,
  Status.CONFIRM,
];

const webPortalDisplayStatuses: string[] = [
  Status.REQUIRED,
  Status.SUBMITTED,
  Status.REJECTED,
  Status.APPROVED,
  Status.EXPIRED,
  Status.START_TRAINING,
  Status.WAITING,
  Status.CONFIRM,
];

const documentStatuses: IDocumentStatusProps[] = [
  {
    name: MENU_STATUSES.REQUIRED,
    color: theme.palettes.documentStatus.required,
    textColor: theme.palettes.documentStatusText.required,
  },
  {
    name: MENU_STATUSES.PENDING,
    color: theme.palettes.documentStatus.pending,
    textColor: theme.palettes.documentStatusText.pending,
  },
  {
    name: MENU_STATUSES.SUBMITTED,
    color: theme.palettes.documentStatus.submitted,
    textColor: theme.palettes.documentStatusText.submitted,
  },
  {
    name: MENU_STATUSES.REJECTED,
    color: theme.palettes.documentsStatus.rejected,
    textColor: theme.palettes.documentStatusText.rejected,
  },
  {
    name: MENU_STATUSES.APPROVED,
    color: theme.palettes.documentsStatus.approved,
    textColor: theme.palettes.documentStatusText.approved,
  },
  {
    name: MENU_STATUSES.EXPIRED,
    color: theme.palettes.documentsStatus.expired,
    textColor: theme.palettes.documentStatusText.expired,
  },
  {
    name: MENU_STATUSES.START_TRAINING,
    color: theme.palettes.documentStatus.wait,
    textColor: theme.palettes.documentStatusText.wait,
  },
  {
    name: MENU_STATUSES.WAITING,
    color: theme.palettes.documentsStatus.wait,
    textColor: theme.palettes.documentStatusText.wait,
  },
  {
    name: MENU_STATUSES.CONFIRM,
    color: theme.palettes.documentsStatus.confirm,
    textColor: theme.palettes.documentsStatusText.confirm,
  },
];

function getStatus(name: string) {
  return documentStatuses.find(status => status?.name === name?.trim());
}

function getIcon(status: IDocumentStatusProps) {
  const statusName = status.name.trim();
  if (statusName === Status.REJECTED || statusName === Status.EXPIRED) {
    return <CloseCircleOutlined style={{ color: status.textColor }} />;
  } else if (
    statusName === Status.REQUIRED ||
    statusName === Status.START_TRAINING ||
    statusName === Status.SUBMITTED
  ) {
    return <InfoCircleOutlined style={{ color: status.textColor }} />;
  } else if (statusName === Status.APPROVED) {
    return <CheckCircleOutlined style={{ color: status.textColor }} />;
  } else if (statusName === Status.WAITING) {
    return <CheckCircleOutlined style={{ color: status.textColor }} />;
  } else if (statusName === Status.CONFIRM) {
    return <CheckCircleOutlined style={{ color: status.textColor }} />;
  } else {
    return <CheckCircleOutlined style={{ color: status.textColor }} />;
  }
}

function shouldDisplay(isWebView: boolean, status: IDocumentStatusProps) {
  const statusName = status.name.trim();
  if (isWebView && webViewDisplayStatuses.includes(statusName)) {
    return true;
  } else if (!isWebView && webPortalDisplayStatuses.includes(statusName)) {
    return true;
  } else {
    return false;
  }
}

interface DocumentStatusProps {
  statusName: string;
}

const DocumentStatus: React.FC<DocumentStatusProps> = props => {
  const isWebView = useIsWebView();
  const { statusName } = props;
  const status = getStatus(statusName);
  return status && shouldDisplay(isWebView, status) ? (
    <>
      <StatusTag
        style={{
          color: status.textColor,
          backgroundColor: status.color,
        }}
        icon={getIcon(status)}
      >
        {status.name}
      </StatusTag>
    </>
  ) : (
    <></>
  );
};

export default DocumentStatus;
